import ApplicationController from "./application_controller";

export default class extends ApplicationController {
    connect() {
        super.connect()
    }

    toggle(event) {
        const quoteId = this.element.dataset.additionalServiceToggleQuoteId
        const serviceKey = event.target.value
        const checked = event.target.checked
        this.stimulate("QuoteFlowReflex#toggle_additional_service", quoteId, serviceKey, checked)
    }
}

